import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      (_ctx.accountingPeriod)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.accountingItemImportId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountingItemImportId) = $event)),
                  items: _ctx.accountingItemImports,
                  label: "Fichier importé (FEC, ...)",
                  "item-title": _ctx.getAccountingItemImportTitle,
                  "item-value": "id",
                  density: "compact"
                }, null, 8, ["modelValue", "items", "item-title"])
              ]),
              _: 1
            }),
            (_ctx.accountingItemImportId)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "12",
                  class: "d-flex justify-center align-right mb-2 align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_switch, {
                      modelValue: _ctx.moveDocumentIfFileAsMiscelleanous,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.moveDocumentIfFileAsMiscelleanous) = $event)),
                      label: "Garder les justificatifs",
                      "hide-details": "",
                      class: "mr-4 mt-0"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_btn, {
                      rounded: "",
                      elevation: "0",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => {
                        _ctx.deleteLoading = false;
                        _ctx.deleteDialog = true;
                    }),
                      disabled: !_ctx.toDeleteDocuments.length && !_ctx.toDeleteBankTransactions.length,
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" Supprimer ")
                      ])),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.accountingItemImportId)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "12",
                  class: "mx-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tabs, {
                      modelValue: _ctx.tab,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tab) = $event)),
                      grow: "",
                      density: "compact",
                      variant: "centered"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tab, {
                          value: "bankTransaction",
                          "data-cy": "AccountingPeriodOpening-bankTransaction"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_badge, {
                              color: "success",
                              content: _ctx.bankTransactions.length || '-',
                              location: "end",
                              inline: ""
                            }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createTextVNode(" Transactions bancaires ")
                              ])),
                              _: 1
                            }, 8, ["content"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tab, {
                          value: "documents",
                          "data-cy": "AccountingPeriodOpening-documents"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_badge, {
                              color: "success",
                              content: _ctx.badgeDocumentNumber || '-',
                              location: "end",
                              inline: ""
                            }, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createTextVNode(" Documents ")
                              ])),
                              _: 1
                            }, 8, ["content"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_window, {
                      modelValue: _ctx.tab,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tab) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, { value: "bankTransaction" }),
                        _createVNode(_component_v_window_item, { value: "documents" })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_v_window, {
                      modelValue: _ctx.tab,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.tab) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, {
                          value: "bankTransaction",
                          class: "pa-5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, {
                              class: "default_card_wm",
                              width: "100%"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_text, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            (_ctx.bankTransactions.length)
                                              ? (_openBlock(), _createBlock(_component_v_row, {
                                                  key: 0,
                                                  class: "mb-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_col, {
                                                      cols: "6",
                                                      class: "d-flex justify-end"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (
                                                        _ctx.toDeleteBankTransactions &&
                                                        _ctx.bankTransactions.length !==
                                                            _ctx.toDeleteBankTransactions.length
                                                    )
                                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 0,
                                                              elevation: "0",
                                                              rounded: "",
                                                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectAllBankTransactions())),
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                                _createTextVNode(" Sélectionner toutes les lignes bancaires ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 1,
                                                              elevation: "0",
                                                              rounded: "",
                                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.diselectAllBankTransactions())),
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                                _createTextVNode(" Désélectionner toutes les lignes bancaires ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_v_list, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_virtual_scroll, {
                                                  items: _ctx.bankTransactions,
                                                  height: "500",
                                                  "item-height": "70"
                                                }, {
                                                  default: _withCtx(({ item }) => [
                                                    (_openBlock(), _createBlock(_component_v_list_item, {
                                                      key: item.id,
                                                      class: "oss-list-item",
                                                      style: _normalizeStyle({
                                                            background:
                                                                _ctx.bankTransactionSelected &&
                                                                _ctx.bankTransactionSelected.id ===
                                                                    item.id
                                                                    ? 'rgba(109, 192, 189, 0.3)'
                                                                    : '',
                                                        })
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              cols: "1",
                                                              class: "d-flex align-center",
                                                              onClick: ($event: any) => (
                                                                    _ctx.selectedBankTransaction(item.id)
                                                                )
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_icon, {
                                                                  color: 
                                                                        _ctx.isToDeleteBankTransaction(
                                                                            item.id,
                                                                        )
                                                                            ? 'secondary'
                                                                            : ''
                                                                    
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.isToDeleteBankTransaction(
                                                                            item.id,
                                                                        )
                                                                            ? "$check_box"
                                                                            : "$check_box_outline_blank"), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["color"])
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"]),
                                                            _createVNode(_component_v_col, {
                                                              cols: "11",
                                                              onClick: ($event: any) => (
                                                                    _ctx.bankTransactionSelected = item
                                                                )
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item_title, {
                                                                  class: _normalizeClass({
                                                                        'text-decoration-line-through text--secondary':
                                                                            _ctx.isToDeleteBankTransaction(
                                                                                item.id,
                                                                            ),
                                                                    })
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(item.wordingOriginal), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["class"]),
                                                                _createVNode(_component_v_list_item_subtitle, {
                                                                  class: _normalizeClass({
                                                                        'text-decoration-line-through text--secondary d-flex justify-space-between':
                                                                            _ctx.isToDeleteBankTransaction(
                                                                                item.id,
                                                                            ),
                                                                    })
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(
                                                                                item.dateDebit,
                                                                            )), 1),
                                                                    _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                item.amount,
                                                                                undefined,
                                                                            )), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["class"])
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["style"]))
                                                  ]),
                                                  _: 1
                                                }, 8, ["items"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, {
                          value: "documents",
                          class: "pa-5"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, {
                              class: "default_card_wm",
                              width: "100%"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card_text, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            (_ctx.documents.length)
                                              ? (_openBlock(), _createBlock(_component_v_row, {
                                                  key: 0,
                                                  class: "mb-2"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_col, {
                                                      cols: "6",
                                                      class: "d-flex justify-end"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (
                                                        _ctx.documents.length !==
                                                        _ctx.toDeleteDocuments.length
                                                    )
                                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 0,
                                                              elevation: "0",
                                                              rounded: "",
                                                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectAllDocuments())),
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                                _createTextVNode(" Sélectionner tous les documents ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 1,
                                                              elevation: "0",
                                                              rounded: "",
                                                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.diselectAllDocuments())),
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                                _createTextVNode(" Désélectionner tous les documents ")
                                                              ])),
                                                              _: 1
                                                            }))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_v_list, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_virtual_scroll, {
                                                  items: _ctx.documents,
                                                  height: "500",
                                                  "item-height": "70"
                                                }, {
                                                  default: _withCtx(({ item }) => [
                                                    (_openBlock(), _createBlock(_component_v_list_item, {
                                                      key: item.id,
                                                      class: "oss-list-item",
                                                      style: _normalizeStyle({
                                                            background:
                                                                _ctx.documentSelected &&
                                                                _ctx.documentSelected.id === item.id
                                                                    ? 'rgba(109, 192, 189, 0.3)'
                                                                    : '',
                                                        })
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, {
                                                              cols: "1",
                                                              class: "d-flex align-center",
                                                              onClick: ($event: any) => (_ctx.selectedDocument(item.id))
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_icon, {
                                                                  color: 
                                                                        _ctx.isToDeleteDocument(item.id)
                                                                            ? 'secondary'
                                                                            : ''
                                                                    
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.isToDeleteDocument(item.id)
                                                                            ? "$check_box"
                                                                            : "$check_box_outline_blank"), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["color"])
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"]),
                                                            _createVNode(_component_v_col, {
                                                              cols: "11",
                                                              onClick: ($event: any) => (_ctx.documentSelected = item)
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item_title, {
                                                                  class: _normalizeClass({
                                                                        'text-decoration-line-through text--secondary':
                                                                            _ctx.isToDeleteDocument(
                                                                                item.id,
                                                                            ),
                                                                    })
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(_ctx.getDocumentTitle(item)), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["class"]),
                                                                _createVNode(_component_v_list_item_subtitle, {
                                                                  class: _normalizeClass({
                                                                        'text-decoration-line-through text--secondary d-flex justify-space-between':
                                                                            _ctx.isToDeleteDocument(
                                                                                item.id,
                                                                            ),
                                                                    })
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.date)), 1),
                                                                    _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                                item.grossAmountSigned,
                                                                                undefined,
                                                                            )), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["class"])
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["onClick"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["style"]))
                                                  ]),
                                                  _: 1
                                                }, 8, ["items"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_col, {
                  key: 2,
                  cols: "12",
                  class: "d-flex justify-center"
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode(" Aucune pièce n'a été detectée pour cette periode ")
                  ])),
                  _: 1
                }))
          ], 64))
        : (_openBlock(), _createBlock(_component_v_col, {
            key: 1,
            cols: "12",
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode(" Pas de période précédente ")
            ])),
            _: 1
          })),
      (_ctx.deleteDialog)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 2,
            modelValue: _ctx.deleteDialog,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.deleteDialog) = $event)),
            title: "Suppression des éléments sélectionnés",
            onValid: _ctx.valid,
            validLoading: _ctx.deleteLoading
          }, {
            default: _withCtx(() => [
              (!_ctx.stepData || !_ctx.stepData.action)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_1, " Êtes-vous sûr(e) de vouloir supprimer les éléments sélectionnés ? "))
                : _createCommentVNode("", true),
              (_ctx.stepData && !!_ctx.stepData.action)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_2, "Suppression en cours"))
                : _createCommentVNode("", true),
              (_ctx.stepData && !!_ctx.stepData.action)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 2,
                    color: "secondary",
                    height: "10",
                    stream: "",
                    class: "ml-2",
                    "model-value": _ctx.stepData.progressValue
                  }, null, 8, ["model-value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "onValid", "validLoading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}